const testimonials = [
  {
    name: "Carlos M.",
    location: "Key West, FL",
    rating: 5,
    text: "Had a fishing charter to the Bahamas in 4 days and my passport was expired. Fast Passport Center pulled it off in 3 days flat. Their daily updates kept me sane. Can't recommend them enough.",
    service: "Passport Renewal",
  },
  {
    name: "Sandra T.",
    location: "Marathon, FL",
    rating: 5,
    text: "My son's passport was damaged right before our family cruise. I was in full panic mode. FPC handled everything — gave me a clear checklist, told me exactly which forms, and got us a replacement in under a week.",
    service: "Damaged Passport",
  },
  {
    name: "Robert K.",
    location: "Stock Island, FL",
    rating: 5,
    text: "First-time passport at 62 years old — I had no clue where to start. They sent me a step-by-step guide, told me which clerk to visit in Key West, and handled the expedite after. Couldn't have been easier.",
    service: "New Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function KeyWestTestimonialsSection() {
  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Key West &amp; Florida Keys Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Key West, Marathon, and Stock Island who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-[#F7F8FA] border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}